package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.AuthState
import com.example.readingnotes.domain.repository.AuthRepository
import com.example.readingnotes.util.Result

class AdminLoginUseCase(
    private val authRepository: AuthRepository,
) {
    suspend operator fun invoke(password: String): Result<AuthState> {
        if (password.isBlank()) {
            return Result.failure(IllegalArgumentException("パスワードを入力してください"))
        }
        return authRepository.login(password)
    }
}
